export const generalKey = 'product_ps_bay_bay';
export const whiteLocaleList = ['jp']; //白名单
export const productPageUrl = 'delta-3-1000-air-portabe-power-station';
export const tabsValues = ['Product', 'Specs', 'Support'];
export const productPageTheme = 'black'; //主题色

export const shopNowLink: any = {
    jp: {
        nav: 'https://jp.ecoflow.com/pages/products-delta-3-1000-air-portable-power-station',
    },
};

export const generalKeys = [
    {
        key: 'product_ps_bay_bay',
        url: 'delta-3-1000-air-portabe-power-station',
    },
];
